import axios from 'axios';

export const originAxios = axios.create();
axios.interceptors.response.use((response) => response.data, (error) => Promise.reject((error.response || {}).data));

/**
 * 返回公共的请求实例对象
 */
export const instance = axios.create();
instance.defaults.headers.get['Content-type'] = 'application/json; charset=UTF-8';
instance.interceptors.request.use(
    (config) => {
        if (config.method === 'get') {
            config.data = {unused: 0}; // 这个是关键点，加入这行就可以了
            config.params = {
                ...config.params
            };
        }
        return config;
    },
    (error) => Promise.reject(error)
);
instance.interceptors.response.use((response) => response.data, (error) => Promise.reject(error.response.data));
